import { render, staticRenderFns } from "./AsistenteOrdenModal.vue?vue&type=template&id=cbc4231a&scoped=true"
import script from "./AsistenteOrdenModal.vue?vue&type=script&lang=js"
export * from "./AsistenteOrdenModal.vue?vue&type=script&lang=js"
import style0 from "./AsistenteOrdenModal.vue?vue&type=style&index=0&id=cbc4231a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc4231a",
  null
  
)

export default component.exports